import { INSERT_UPDATE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE, GET_DELEGATE_B2B_TIMESLOT_ACTION_TYPE, DELETE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE } from "../../../utils/constants"


const initialState = [];

function delegate_B2B_TimeSlot_Reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INSERT_UPDATE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_B2B_TIMESLOT_ACTION_TYPE:
            return [...state, payload];
        case DELETE_DELEGATE_B2B_TIMESLOT_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default delegate_B2B_TimeSlot_Reducer;